import { render, staticRenderFns } from "./broadside.vue?vue&type=template&id=5eba54e9"
import script from "./broadside.vue?vue&type=script&lang=js"
export * from "./broadside.vue?vue&type=script&lang=js"
import style0 from "./broadside.vue?vue&type=style&index=0&id=5eba54e9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports